import { HHBox, HHChip, HHStack } from '@hinge-health/react-component-library';
import { ActiveStatus } from '../../../billing-tool/utils/contract-utils';
import {
  SubscriptionEstimateStatusFilter,
  SUBSCRIPTION_ESTIMATES_STATUS_FILTER_TEST_ID_PREFIX,
} from './types';

interface StatusFilterOption {
  label: string;
  value: SubscriptionEstimateStatusFilter;
}

const STATUS_FILTER_OPTIONS: StatusFilterOption[] = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: ActiveStatus.Active },
  { label: 'Past', value: ActiveStatus.Past },
  { label: 'Future', value: ActiveStatus.Future },
];

interface StatusQuickFiltersProps {
  selected: SubscriptionEstimateStatusFilter;
  onSelect: (value: SubscriptionEstimateStatusFilter) => void;
}

// HHChip only forwards data-testid in variant-bypass mode; the filled/outlined
// styling this filter mirrors drops it. The per-chip test id lives on the HHBox
// wrapper (which spreads props) so the chip styling stays exact.
export const StatusQuickFilters = ({
  selected,
  onSelect,
}: StatusQuickFiltersProps): JSX.Element => (
  <HHStack
    direction="row"
    alignItems="center"
    spacing={2}
    sx={{ paddingLeft: 6 }}
  >
    {STATUS_FILTER_OPTIONS.map(option => {
      const isSelected = selected === option.value;

      return (
        <HHBox
          key={option.value}
          data-testid={`${SUBSCRIPTION_ESTIMATES_STATUS_FILTER_TEST_ID_PREFIX}-${option.value}`}
        >
          <HHChip
            clickable
            label={option.label}
            size="small"
            hhVariant={isSelected ? 'filled' : 'outlined'}
            color={isSelected ? 'neutral' : 'default'}
            onClick={(): void => onSelect(option.value)}
          />
        </HHBox>
      );
    })}
  </HHStack>
);
